<template>
  <div class="custom-select-button">
    <div
      class="custom-select-button__content"
      :class="{ inline: mode === 'inline' }"
    >
      <div class="title">{{ title }}</div>
      <div class="options">
        <SelectButton
          v-model="internalValue"
          :options="options"
          :option-label="optionName"
          :option-value="optionValue"
        >
          <template #option="slotProps">
            <div class="option" :style="{ color: slotProps.option.color }">
              <div>{{ slotProps.option[optionName] || '' }}</div>
            </div>
          </template>
        </SelectButton>
      </div>
    </div>
  </div>
</template>

<script>
  import SelectButton from 'primevue/selectbutton'

  export default {
    components: {
      SelectButton,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        required: true,
      },
      modelValue: {
        type: Number,
        required: false,
        default: null,
      },
      mode: {
        type: String,
        required: false,
        default: '',
      },
      optionName: {
        type: String,
        required: false,
        default: 'label',
      },
      optionValue: {
        type: String,
        required: false,
        default: 'value',
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        internalValue: null,
      }
    },
    watch: {
      internalValue(newValue) {
        this.$emit('update:modelValue', newValue)
      },
      modelValue(newValue) {
        this.internalValue = newValue
      },
    },
  }
</script>

<style lang="scss" scoped>
  .custom-select-button {
    &__content {
      &.inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      ::v-deep(.options .p-selectbutton.p-buttonset) {
        display: flex;
      }

      ::v-deep(.options .p-selectbutton.p-buttonset .p-button) {
        border-radius: 5px !important;

        background-color: white;
        border: 1px solid #ced4da;

        &:hover {
          background: #e9ecef;
        }

        &:not(:first-child) {
          margin-left: 20px;
        }

        .option {
          font-weight: 600;
          color: #555;
        }

        &.p-highlight {
          border: 2px solid darken(#ced4da, 30%);
          background-color: #eaeaea;
        }
      }
    }
  }
</style>
